import ResourceOffers from 'core/ResourceOffers'
import { connect } from 'react-redux'
import { urlResource } from 'common/utils'

const mapStateToProps = (state, { match }) => ({
  resource: urlResource(match.path)
})

export default connect(mapStateToProps)(ResourceOffers)
